<script setup>
import { useAttrs, ref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
const mascotUrl = ref('/secretaria-mascot.png');
</script>

<template>
  <!-- One Channel Mascot Logo (yellow cat) -->
  <img
    v-bind="attrs"
    :src="mascotUrl"
    alt="One Channel"
    class="object-contain"
  />
</template>
